import types from "./actionTypes";
import { dealWithUserTriggers } from '../../undoredo/actions'
import { getUserTriggers, getUserTriggersOfSelectedDelegate } from './selectors';
import { arrayMove } from '../../../services/builder/util.js'


export const addUserTrigger = (payload, noUndoRedo) => (dispatch) => {

	if (noUndoRedo != true)
		dispatch(dealWithUserTriggers({ ...payload }, 'add'))

	dispatch({
		type: types.ADD_USER_TRIGGER,
		payload,
	})
};

export const editUserTrigger = (payload, noUndoRedo) => (dispatch) => {

	if (noUndoRedo != true)
		dispatch(dealWithUserTriggers(payload, 'edit'))

	dispatch({
		type: types.EDIT_USER_TRIGGER,
		payload,
	})
};


export const deleteUserTrigger = (payload) => ({
	type: types.DELETE_USER_TRIGGER,
	payload
})

export const updateFullUserTriggers = (userTriggers) => ({
	type: types.UPDATE_FULL_USER_TRIGGERS,
	payload: userTriggers
})


export const moveOneUserTriggerUpDown = (userTriggerId, parent, direction) => (dispatch, getState) => {

	let userTriggers = getUserTriggers(getState());
	let currentUt = userTriggers.find(userTrigger => userTrigger.id === userTriggerId);

	let currentIndex = userTriggers.findIndex(userTrigger => userTrigger.id === userTriggerId);
	let newUserTriggers = arrayMove(userTriggers, currentIndex, direction == 'up' ? currentIndex - 1 : currentIndex + 1);


	dispatch({
		type: types.UPDATE_REORDERED_USERTRIGGERS,
		payload: newUserTriggers
	})
}


export const resetUserTriggers = (userTriggers) => ({
	type: types.RESET_USER_TRIGGERS,
	payload: userTriggers
})